import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useMyInfo } from 'shared/src/queries';
import { aiStudioService } from 'shared/src/api';

type EntryPoint = 'GOODS_DETAIL_REVIEW' | 'GOODS_DETAIL_SIZE';

export const useAiFittingRedirectPath = (entryPoint: EntryPoint) => {
  const goodsSno = useGoodsSno();
  const { data: me } = useMyInfo();

  return useQuery({
    enabled: !me.is_anonymous,
    queryKey: [
      ...queryKey.goodsRepresentativeImagesRedirectPath(goodsSno),
      entryPoint,
    ],
    queryFn: () =>
      aiStudioService.getRepresentativeImageRedirectPath({
        goods_sno: goodsSno,
        entry_point: entryPoint,
      }),
  });
};
